export const FETCH_PRODUCT_PENDING = "FETCH_PRODUCT_PENDING";
export const FETCH_PRODUCT_REJECTED = "FETCH_PRODUCT_REJECTED";
export const FETCH_PRODUCT_FULFILLED = "FETCH_PRODUCT_FULFILLED";
export const ADD_BASKET_PENDING = "ADD_BASKET_PENDING";
export const ADD_BASKET_REJECTED = "ADD_BASKET_REJECTED";
export const ADD_BASKET_FULFILLED = "ADD_BASKET_FULFILLED";
export const CLEAR_PRODUCT_DETAIL = 'CLEAR_PRODUCT_DETAIL';




// WEBPACK FOOTER //
// ./src/constants/productDetail.js